import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import { api } from "../../api/api";
import { IStoreState } from "../initialStoreState";
import { showMessage } from "../messages/messagesActions";
import {
  IAnalyticModule,
  IAnalytics,
  IStateWiseSalesAnalytics,
} from "./analytics.types";
import { get_module_name_path } from "./analytics.constants";

export const FETCH_ANALYTICS_LIST_PROGRESS = "FETCH_ANALYTICS_LIST_PROGRESS";
export const FETCH_ANALYTICS_LIST_SUCCESS = "FETCH_ANALYTICS_LIST_SUCCESS";
export const FETCH_ANALYTICS_LIST_FAILED = "FETCH_ANALYTICS_LIST_FAILED";

//  Invoice Analytics List action creators
export const fetchInvoiceAnalyticsListProgress = () =>
  action(FETCH_ANALYTICS_LIST_PROGRESS);
export const fetchInvoiceAnalyticsListSuccess = (
  data: IAnalytics[],
  totalRecords: number,
) => action(FETCH_ANALYTICS_LIST_SUCCESS, { data, totalRecords });
export const fetchInvoiceAnalyticsListFailed = () =>
  action(FETCH_ANALYTICS_LIST_FAILED);

export const fetchModuleAnalyticsWithArgsAsync =
  ({
    module,
    from_data,
    to_date,
    cdn_type,
    billing_company_uuid,
    // billing_company_branch_uuid,
  }: {
    module: IAnalyticModule;
    from_data: string;
    to_date: string;
    billing_company_uuid: string;
    // billing_company_branch_uuid:string;
    cdn_type: "CREDIT" | "DEBIT" | null;
  }): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch, getState) => {
    try {
      let module_path_url = get_module_name_path[module];
      let cdn_type_url = "";
      if (cdn_type) {
        cdn_type_url += `type=${cdn_type}&`;
      }

      dispatch(fetchInvoiceAnalyticsListProgress());
      let finalUrl = `/analytics/get-${module_path_url}-analytics?from_date=${from_data}&to_date=${to_date}&billing_company_uuid=${billing_company_uuid}`;
      // console.log(billing_company_uuid,billing_company_branch_uuid,"finalUrl123");
      const res = await api.get(finalUrl);
      const data: IAnalytics[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchInvoiceAnalyticsListSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchInvoiceAnalyticsListFailed());
      dispatch(
        showMessage({
          type: "error",
          message: err.response.data.message,
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_ANNUAL_SALES_ANALYTICS_PROGRESS =
  "FETCH_ANNUAL_SALES_ANALYTICS_PROGRESS";
export const FETCH_ANNUAL_SALES_ANALYTICS_SUCCESS =
  "FETCH_ANNUAL_SALES_ANALYTICS_SUCCESS";
export const FETCH_ANNUAL_SALES_ANALYTICS_FAILED =
  "FETCH_ANNUAL_SALES_ANALYTICS_FAILED";

//  Annual Sales Analytics action creators
export const fetchAnnualSalesAnalyticsProgress = () =>
  action(FETCH_ANNUAL_SALES_ANALYTICS_PROGRESS);
export const fetchAnnualSalesAnalyticsSuccess = (
  data: IAnalytics[],
  totalRecords: number,
) => action(FETCH_ANNUAL_SALES_ANALYTICS_SUCCESS, { data, totalRecords });
export const fetchAnnualSalesAnalyticsFailed = () =>
  action(FETCH_ANNUAL_SALES_ANALYTICS_FAILED);

export const fetchAnnualSalesInvoiceAnalyticsAsync =
  (
    year: string,
    billingCompanyUUID: string,
    billingBranchUUID: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      let url = "";
      if (billingCompanyUUID && billingBranchUUID) {
        url += `&billing_company_uuid=${billingCompanyUUID}&billing_company_branch_uuid=${billingBranchUUID}`;
      }
      if (year) {
        url += `&year=${year}`;
      }
      dispatch(fetchAnnualSalesAnalyticsProgress());
      const res = await api.get(
        `/analytics/get-sales-invoice-annual-analytics?${url}`,
      );
      const data: IAnalytics[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchAnnualSalesAnalyticsSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchAnnualSalesAnalyticsFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message ||
            "Failed to fetch annual sales analytics",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const FETCH_ANNUAL_PURCHASE_ANALYTICS_PROGRESS =
  "FETCH_ANNUAL_PURCHASE_ANALYTICS_PROGRESS";
export const FETCH_ANNUAL_PURCHASE_ANALYTICS_SUCCESS =
  "FETCH_ANNUAL_PURCHASE_ANALYTICS_SUCCESS";
export const FETCH_ANNUAL_PURCHASE_ANALYTICS_FAILED =
  "FETCH_ANNUAL_PURCHASE_ANALYTICS_FAILED";

//  Annual purchase Analytics action creators
export const fetchAnnualPurchaseAnalyticsProgress = () =>
  action(FETCH_ANNUAL_PURCHASE_ANALYTICS_PROGRESS);
export const fetchAnnualPurchaseAnalyticsSuccess = (
  data: IAnalytics[],
  totalRecords: number,
) => action(FETCH_ANNUAL_PURCHASE_ANALYTICS_SUCCESS, { data, totalRecords });
export const fetchAnnualPurchaseAnalyticsFailed = () =>
  action(FETCH_ANNUAL_PURCHASE_ANALYTICS_FAILED);

export const fetchAnnualPurchaseInvoiceAnalyticsAsync =
  (
    year: string,
    billingCompanyUUID: string,
    billingBranchUUID: string,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      let url = "";
      if (billingCompanyUUID && billingBranchUUID) {
        url += `&billing_company_uuid=${billingCompanyUUID}&billing_company_branch_uuid=${billingBranchUUID}`;
      }
      if (year) {
        url += `&year=${year}`;
      }
      dispatch(fetchAnnualPurchaseAnalyticsProgress());
      const res = await api.get(
        `/analytics/get-purchase-invoice-annual-analytics?${url}`,
      );
      const data: IAnalytics[] = res.data.data;
      const totalRecords = res.data.totalRecords;
      dispatch(fetchAnnualPurchaseAnalyticsSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchAnnualPurchaseAnalyticsFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message ||
            "Failed to fetch annual purchase analytics",
          displayAs: "snackbar",
        }),
      );
    }
  };

export const CLEAR_ANALYTICS_LIST = "CLEAR_ANALYTICS_LIST";
export const CLEAR_ANALYTICS_STATE = "CLEAR_ANALYTICS_STATE";

export const clearAnalyticsListSync = () => action(CLEAR_ANALYTICS_LIST);
export const clearAnalyticsCompanyState = () => action(CLEAR_ANALYTICS_STATE);

// State-wise Sales Analytics
export const FETCH_STATE_WISE_SALES_ANALYTICS_PROGRESS =
  "FETCH_STATE_WISE_SALES_ANALYTICS_PROGRESS";
export const FETCH_STATE_WISE_SALES_ANALYTICS_SUCCESS =
  "FETCH_STATE_WISE_SALES_ANALYTICS_SUCCESS";
export const FETCH_STATE_WISE_SALES_ANALYTICS_FAILED =
  "FETCH_STATE_WISE_SALES_ANALYTICS_FAILED";

// State-wise Sales Analytics action creators
export const fetchStateWiseSalesAnalyticsProgress = () =>
  action(FETCH_STATE_WISE_SALES_ANALYTICS_PROGRESS);
export const fetchStateWiseSalesAnalyticsSuccess = (
  data: IStateWiseSalesAnalytics[],
  totalRecords: number,
) => action(FETCH_STATE_WISE_SALES_ANALYTICS_SUCCESS, { data, totalRecords });
export const fetchStateWiseSalesAnalyticsFailed = () =>
  action(FETCH_STATE_WISE_SALES_ANALYTICS_FAILED);

export const fetchStateWiseSalesAnalyticsAsync =
  (params: {
    from_date: string;
    to_date: string;
    billing_company_uuid: string;
    billing_company_branch_uuid: string;
  }): ThunkAction<void, IStoreState, {}, AnyAction> =>
  async (dispatch) => {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) =>
        queryParams.append(key, value.toString()),
      );

      dispatch(fetchStateWiseSalesAnalyticsProgress());
      const res = await api.get(
        `/analytics/get-state-wise-sale-invoice?table_name=latest_invoices&${queryParams.toString()}`,
      );
      const data: IStateWiseSalesAnalytics[] = res.data.data;
      const totalRecords = res.data.totalRecords || data.length;
      dispatch(fetchStateWiseSalesAnalyticsSuccess(data, totalRecords));
    } catch (err: any) {
      dispatch(fetchStateWiseSalesAnalyticsFailed());
      dispatch(
        showMessage({
          type: "error",
          message:
            err.response?.data?.message ||
            "Failed to fetch state-wise sales analytics",
          displayAs: "snackbar",
        }),
      );
    }
  };
